const CACHE_KEY = 'academy_access';
export const ACADEMY_ADMIN_API = '/admin/academy';

export function getCachedAcademies() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    return [];
  }
}

export function setCachedAcademies(academies) {
  sessionStorage.setItem(CACHE_KEY, JSON.stringify(academies || []));
}

export function academySettingsPath(academies = getCachedAcademies()) {
  if (academies.length === 1) {
    return `/academy-subscriptions/${academies[0].id}`;
  }
  return '/academy-subscriptions';
}

export function academyPaymentsPath(academies = getCachedAcademies()) {
  if (academies.length === 1) {
    return `/academy-payments/${academies[0].id}`;
  }
  return '/academy-payments';
}

export function academyTreasurerPath(academies = getCachedAcademies()) {
  if (academies.length === 1) {
    return `/academy-treasurer/${academies[0].id}`;
  }
  return '/academy-treasurer';
}

export const ACADEMY_ROLE_ADMIN = 'Academy Admin';
export const ACADEMY_ROLE_SECRETARY = 'Club Secretary';
export const ACADEMY_ROLE_TREASURER = 'Treasurer';

export const ACADEMY_ROLE_OPTIONS = [
  {
    id: ACADEMY_ROLE_ADMIN,
    label: 'Academy Admin',
    detail: 'Can edit the academy',
  },
  {
    id: ACADEMY_ROLE_SECRETARY,
    label: 'Club Secretary',
    detail: 'Parent subscription status and names',
  },
  {
    id: ACADEMY_ROLE_TREASURER,
    label: 'Treasurer',
    detail: 'Treasurer Reports',
  },
];

export function personRoles(person) {
  if (Array.isArray(person?.roles) && person.roles.length) {
    return person.roles.filter(Boolean);
  }
  if (person?.role) {
    return String(person.role).split(',').map((role) => role.trim()).filter(Boolean);
  }
  return [];
}

export function personHasKnownRole(person) {
  const roles = personRoles(person);
  return ACADEMY_ROLE_OPTIONS.some((option) => roles.includes(option.id));
}

export function academiesForRole(academies, role) {
  return (academies || []).filter((academy) => {
    const roles = Array.isArray(academy?.my_roles) ? academy.my_roles : null;
    if (!roles) {
      return role !== ACADEMY_ROLE_TREASURER;
    }
    return roles.includes(role);
  });
}

export function canOpenAcademySettings(academy) {
  if (!Array.isArray(academy?.my_roles)) {
    return true;
  }
  return academy.my_roles.includes(ACADEMY_ROLE_ADMIN);
}

export function academyHasRole(academy, role) {
  return Array.isArray(academy?.my_roles) && academy.my_roles.includes(role);
}

export function academySettingsPathFor(academies, academyId, isSuperAdmin = false) {
  if (!academyId) {
    return null;
  }
  if (isSuperAdmin) {
    return `/academy-subscriptions/${academyId}`;
  }
  const academy = (academies || []).find((row) => String(row.id) === String(academyId));
  return academy && academyHasRole(academy, ACADEMY_ROLE_ADMIN)
    ? `/academy-subscriptions/${academyId}`
    : null;
}

export function academyTreasurerPathFor(academies, academyId, isSuperAdmin = false) {
  if (isSuperAdmin) {
    return academyId ? `/academy-treasurer/${academyId}` : academyTreasurerPath(academies);
  }
  if (academyId) {
    const academy = (academies || []).find((row) => String(row.id) === String(academyId));
    return academy && academyHasRole(academy, ACADEMY_ROLE_TREASURER)
      ? `/academy-treasurer/${academyId}`
      : null;
  }
  const allowed = academiesForRole(academies, ACADEMY_ROLE_TREASURER);
  return allowed.length ? academyTreasurerPath(allowed) : null;
}

export function personDisplayName(person) {
  if (!person) {
    return '';
  }
  const name = `${person.first_name || ''} ${person.last_name || ''}`.trim();
  return name || person.role || 'Assigned person';
}
